import { MessageCircleIcon } from 'lucide-react';
import { founder, salon } from '../../data/content';
import { useSite } from '../../contexts/SiteContext';
import { shopLabels } from '../../data/shopLabels';
import { btnOnClay } from '../../ui/styles';

/** Menselijk moment midden in het productraster — zoals een verkoopster die even meekijkt. */
export function AdviceTile() {
  const {
    policy
  } = useSite();
  return <aside className="flex h-full flex-col bg-clay p-5 text-shell sm:p-7" aria-label={`Advies van ${founder.firstName}`} data-id="element-7001" data-mp="39rfxlkti2v79">
      {/* Decoratief: haar naam staat op de knop. */}
      <img src={founder.portrait} alt="" loading="lazy" className="h-14 w-14 rounded-full object-cover" data-id="element-7002" data-mp="3013ezy58xc3r" />
      <p className="mt-6 type-title" data-id="element-7003" data-mp="2v208085pgvt5">Twijfel je tussen twee producten?</p>
      {/* Reactietijd uit de instellingen, zodat hij klopt met de rest van de site ("binnen 24 uur"). */}
      {/* Op klei altijd vol shell (5,6:1); doorschijnend wit haalt AA niet. */}
      <p className="mt-3 text-[14px] leading-relaxed text-shell" data-id="element-7004" data-mp="3np4fcjs9tm83">
        Stuur me een foto van je huid. Ik antwoord persoonlijk binnen {policy.responseHours} uur, ook als je niets bestelt.
      </p>
      <div className="mt-auto pt-6" data-id="element-7005" data-mp="11czqfb1cwcmq">
        <a href={salon.whatsapp} target="_blank" rel="noreferrer" className={`${btnOnClay} w-full`} data-id="element-7006" data-mp="mowms8asdd13">
          <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7007" data-mp="rnpxjsyoupxk" />
          App {founder.firstName}
          <span className="sr-only" data-id="element-7008" data-mp="dnyng3baltou">{shopLabels.viaWhatsApp}</span>
        </a>
      </div>
    </aside>;
}